import { i18n, tokens } from '@simplybenefits/sb-ui-library';

/**
 * Tile definitions for the dashboard.
 * Each tile represents a navigation option available to users.
 */
export const TILES = {
    CLAIMS: {
        title: () => i18n.t(tokens.titles.claims),
        description: () => i18n.t(tokens.labels.dashboard.makeAClaimOrViewClaimsHistory),
        link: '/claims',
        testid: 'claims-tile'
    },
    VIEW_CLAIMS: {
        title: () => i18n.t(tokens.titles.claims),
        description: () => i18n.t(tokens.labels.claims.viewClaimsHistory),
        link: '/claims',
        testid: 'claims-tile'
    },
    SPENDING_ACCOUNTS: {
        title: () => i18n.t(tokens.titles.spendingAccounts),
        description: () => i18n.t(tokens.labels.dashboard.seeYourHealthAndLifestyleAccountBalances),
        link: '/spending-accounts',
        testid: 'spending-accounts-tile'
    },
    MY_USAGE: {
        title: () => i18n.t(tokens.titles["my usage"]),
        description: () => i18n.t(tokens.labels.dashboard.viewYourCoverageUsageAndRemainingBalances),
        link: '/usage',
        testid: 'usage-tile'
    },
    COVERAGE: {
        title: () => i18n.t(tokens.titles.coverage),
        description: () => i18n.t(tokens.labels.dashboard.viewABreakdownOfYourPlanCoverages),
        link: '/coverage',
        testid: 'coverage-tile'
    },
    BENEFITS_CARD: {
        title: () => i18n.t(tokens.titles["benefits card"]),
        description: () => i18n.t(tokens.labels.dashboard.viewYourBenefitsCard),
        link: '/benefits-card',
        testid: 'benefits-card-tile'
    },
    PLAN_DETAILS: {
        title: () => i18n.t(tokens.titles.planDetails),
        description: () => i18n.t(tokens.titles.viewYourPlanDetails),
        link: '/plan-details',
        testid: 'benefits-card-tile'
    },
    MY_ACCOUNT: {
        title: () => i18n.t(tokens.titles["my account"]),
        description: () => i18n.t(tokens.labels.dashboard.viewAndManageAccountDetails),
        link: '/my-account',
        testid: 'myaccount-tile'
    },
    MARKETPLACE: {
        title: () => i18n.t(tokens.titles.marketplace),
        description: () => i18n.t(tokens.labels.dashboard.marketplaceDetails),
        link: '/marketplace'
    }
};

/**
 * Converts a tile definition to a tile object with evaluated i18n strings.
 * @param {Object} tileDef - The tile definition with function properties
 * @returns {Object} The tile object with evaluated strings
 */
export function createTile(tileDef) {
    return {
        title: tileDef.title(),
        description: tileDef.description(),
        link: tileDef.link,
        ...(tileDef.testid && { testid: tileDef.testid })
    };
}